// 定義共用類型
export interface AudioFile {
  name: string;
  path: string;
  category: string;
  isCustom?: boolean;
  audioData?: string; // Base64 encoded audio data for custom uploads
  playbackMode?: PlaybackMode; // 播放模式
}

// 播放模式類型
export enum PlaybackMode {
  LOOP = 'loop',           // 標準循環播放
  SMART_LOOP = 'smartLoop', // 智能循環（帶隨機變化）
  ONCE = 'once',           // 只播放一次
  INTERVAL = 'interval'    // 間隔播放
}

// 間隔播放設定
export interface IntervalSettings {
  minDelay: number;  // 最小延遲時間（秒）
  maxDelay: number;  // 最大延遲時間（秒）
}

export interface Track extends AudioFile {
  isPlaying: boolean;
  volume: number;
  locked: boolean;
  playbackMode?: PlaybackMode; // 播放模式
  intervalSettings?: IntervalSettings; // 間隔播放設定
}

export interface MixPreset {
  id: string;
  name: string;
  tracks: {
    path: string;
    volume: number;
    playbackMode?: PlaybackMode;
    intervalSettings?: IntervalSettings;
  }[];
}